if (!customElements.get('yeelight-tabby')) {
  let sdk;
  const loadSdk = () => sdk ||= new Promise((resolve, reject) => {
    if (window.TabbyPromo) return resolve();
    const script = document.createElement('script');
    script.src = 'https://checkout.tabby.ai/tabby-promo.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.append(script);
  });
  customElements.define('yeelight-tabby', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.data = JSON.parse(this.querySelector('script[type="application/json"]')?.textContent || '{}');
      this.refresh = () => {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const id = form?.querySelector('[name="id"]')?.value || this.data.selected;
        const price = this.dataset.source === 'cart' ? Number(this.dataset.price) : this.data.variants?.[id];
        if (!Number.isFinite(price) || price <= 0 || !this.isConnected || this.lastPrice === price) return;
        this.lastPrice = price;
        const target = this.querySelector('div');
        const fresh = document.createElement('div');
        fresh.id = this.dataset.selector;
        target.replaceWith(fresh);
        new window.TabbyPromo({
          selector: '#' + this.dataset.selector, currency: this.dataset.currency,
          lang: this.dataset.lang === 'ar' ? 'ar' : 'en', source: this.dataset.source,
          price: price.toFixed(2), publicKey: 'pk_019a0850-fcb3-ded9-42c5-484db44f01af',
          merchantCode: 'ksa', shouldInheritBg: false
        });
      };
      loadSdk().then(() => {
        if (!this.isConnected) return;
        this.refresh();
        document.addEventListener('change', this.refresh, {signal:this.controller.signal});
        document.addEventListener('product:variant-change', this.refresh, {signal:this.controller.signal});
      }).catch(() => {});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}